import { combineReducers } from 'redux'
import layoutReducer from 'core/templates/reducer'
import wizardsReducer from 'core/components/wizard/reducer'
import configuratorReducer from './configurator/reducer'
import tradeInReducer, { carInformationsReducer } from './trade-in/reducer'
import stockReducer from './stock/reducer'
import intlReducer from './core/utils/reducers/intl'
import configurationReducer from './configuration/reducer'

const rootReducer = combineReducers({
  intlState: intlReducer,
  wizards: wizardsReducer,
  configurator: configuratorReducer,
  tradeIn: tradeInReducer,
  stock: stockReducer,
  configuration: configurationReducer,
  layout: layoutReducer,
  carInformations: carInformationsReducer
})

export default rootReducer
